import { v4 as uuid } from 'uuid';
import { COLUMNS_NODE_NAME, COLUMN_NODE_NAME } from '../../editor/extensions/columns';
import { ColumnsBlock, ContentBlockType } from '../../model';
import { BlockToTiptapConverter, convertBlocksToTiptapNodes, ConverterContext } from '../blocks-to-tiptap.converter';
import { convertTiptapNodesToBlocks, TiptapToBlockConverter } from '../tiptap-to-blocks.converter';

/**
 * Converts a ColumnsBlock to TipTap columns + column nodes.
 * Recursively converts nested content blocks within each column.
 */
export const convertColumnsBlockToTiptap = ((block, context?: ConverterContext) => {
  return {
    type: COLUMNS_NODE_NAME,
    attrs: {
      id: block.id,
      ...(block.custom_css && { custom_css: block.custom_css }),
      ...(block.custom_style && { custom_style: block.custom_style }),
      ...(block.show_borders && { show_borders: block.show_borders }),
      ...(block.column_widths && { column_widths: block.column_widths }),
    },
    content: block.columns.map((col) => ({
      type: COLUMN_NODE_NAME,
      content: col.content.length ? convertBlocksToTiptapNodes(col.content, context) : [{ type: 'paragraph' }],
    })),
  };
}) satisfies BlockToTiptapConverter<ColumnsBlock>;

/**
 * Converts a TipTap columns node back to a ColumnsBlock.
 * Recursively converts nested content within each column.
 */
export const convertTiptapToColumnsBlock = ((json, context?) => {
  const attrs = json.attrs ?? {};
  const columnNodes = (json.content ?? []).filter((n) => n.type === COLUMN_NODE_NAME);

  return {
    id: (attrs['id'] as string) ?? uuid(),
    type: ContentBlockType.Columns,
    ...(attrs['custom_css'] && { custom_css: attrs['custom_css'] as string }),
    ...(attrs['custom_style'] && { custom_style: attrs['custom_style'] as Record<string, string> }),
    ...(attrs['show_borders'] && { show_borders: attrs['show_borders'] as boolean }),
    ...(attrs['column_widths'] && { column_widths: attrs['column_widths'] as number[] }),
    columns: columnNodes.map((colNode) => ({
      content: colNode.content?.length ? convertTiptapNodesToBlocks(colNode.content, context) : [],
    })),
  };
}) satisfies TiptapToBlockConverter;
